export interface MeddraCodingSummaryProps {
  status: string;
  version?: string;
  term: string;
  code?: string;
}

/** Shared header for editable review and saved Submission coding. */
export function MeddraCodingSummary({ status, version, term, code }: MeddraCodingSummaryProps) {
  return <div className="space-y-1">
    <p className="text-xs text-ink-muted">{status}{version && ` · MedDRA ${version}`}</p>
    <p><strong>{term}</strong>{code && <span className="ml-2 text-xs text-ink-muted">{code}</span>}</p>
  </div>;
}
